// ###################################################上海五零所单灯############################################################
import { request } from '@/utils/request';
import APIURL from '@/api/apiUrl';

/* 单灯设备列表 */
export function heartSingleList(data) {
  return request.post(APIURL.heart.rdcsm50.list, data);
}

/* 单灯列表删除 */
export function deleteSingleList(data) {
  return request.post(APIURL.heart.rdcsm50.delete, data);
}

/* 单灯设备详情 */
export function heartSingleInfo(id) {
  var data = {
    id: id
  };
  return request.get(APIURL.heart.rdcsm50.info, data);
}

/* 下发设备属性写入数据库 */
export function sendAttribute(data) {
  return request.post(APIURL.heart.rdcsm50.sendAttribute, data);
}

/* 修改单灯基本信息 */
export function updateRdcsm(data) {
  return request.post(APIURL.heart.rdcsm50.update, data);
}

/* 招测 */
export function sendHeartBy50(data) {
  return request.post(APIURL.heart.rdcsm50.sendHeartBy50, data);
}

/* 开灯 */
export function openLight(data) {
  return request.post(APIURL.heart.rdcsm50.openlight, data);
}

/* 关灯 */
export function closeLight(data) {
  return request.post(APIURL.heart.rdcsm50.closelight, data);
}

/* 调光 */
export function dimmerLight(data) {
  return request.post(APIURL.heart.rdcsm50.dimmerlight, data);
}

/* 批量开灯 */
export function batchOpenLight(data) {
  return request.post(APIURL.heart.rdcsm50.batchOpenLight, data);
}

/* 批量关灯 */
export function batchCloseLight(data) {
  return request.post(APIURL.heart.rdcsm50.batchCloseLight, data);
}

/* 批量调光 */
export function batchDimmerLight(data) {
  return request.post(APIURL.heart.rdcsm50.batchDimmerLight, data);
}

/* 清除原方案 */
export function clearSiglePlan(data) {
  return request.post(APIURL.heart.rdcsm50.clearSiglePlan, data);
}

/* 请求时钟 */
export function sendSingleTimeSet(data) {
  return request.post(APIURL.heart.rdcsm50.sendSingleTimeSet, data);
}

/* 时钟数据 */
export function clockTimeData(data) {
  return request.post(APIURL.heart.rdcsm50.clockTimeData, data);
}

/* 新增本地控制方案--单灯方案页面 */
export function addLocalControl(data) {
  return request.post(APIURL.heart.rdcsm50.addLocalControl, data);
}

/*  新增本地控制方案列表--单灯方案页面 */
export function addControlList(data) {
  return request.post(APIURL.heart.rdcsm50.addControlList, data);
}

/* 本地控制方案写进数据库 */
export function writeLocalControl(data) {
  return request.post(APIURL.heart.rdcsm50.writeLocalControl, data);
}

/* 本地控制方案列表 */
export function localControlList(data) {
  return request.post(APIURL.heart.rdcsm50.localControlList, data);
}

/* 删除本地控制方案 */
export function deleteControl(data) {
  return request.post(APIURL.heart.rdcsm50.deleteControl, data);
}

/*  本地控制方案详情 */
export function localControlListInfo(id) {
  var data = {
    id: id
  };
  return request.get(APIURL.heart.rdcsm50.localControlListInfo, data);
}

/* 本地方案启用停用 */
export function localControlStatus(data) {
  return request.post(APIURL.heart.rdcsm50.localControlStatus, data);
}

/* 本地方案修改 */
export function updateLocalControl(data) {
  return request.post(APIURL.heart.rdcsm50.updateLocalControl, data);
}

/* 设备绑定方案 */
export function bindPlan(data) {
  return request.post(APIURL.heart.rdcsm50.bindPlan, data);
}

/* 设备绑定详情 */
export function bindPlanInfo(id) {
  var data = {
    terminalId: id
  };
  return request.get(APIURL.heart.rdcsm50.bindPlanInfo, data);
}

// 操作日志列表
export function operationLogList(data) {
  return request.post(APIURL.heart.rdcsm50.operationLogList, data);
}

// 操作日志列表详情
export function operationLogInfo(id) {
  var data = {
    id: id
  };
  return request.get(APIURL.heart.rdcsm50.operationLogInfo, data);
}

// 修改操作日志操作状态
export function operationLogupdate(data) {
  return request.post(APIURL.heart.rdcsm50.operationLogupdate, data);
}

// 发送 参数指令设置
export function sendParamsSet(data) {
  return request.post(APIURL.heart.rdcsm50.sendParamsSet, data);
}

// 查询参数指令（写入数据库）
export function writeParamsSet(data) {
  return request.post(APIURL.heart.rdcsm50.writeParamsSet, data);
}

// 参数指令设置详情
export function paramsSetInfo(id) {
  // 这里传入列表id或者设备id teminalId  二选一
  var data = {
    terminalId: id
  };
  return request.get(APIURL.heart.rdcsm50.paramsSetInfo, data);
}

// 设备上报历史列表
export function reportLogList(data) {
  return request.post(APIURL.heart.rdcsm50.reportLogList, data);
}

// 设备上报历史列表详情
export function reportLogInfo(query) {
  return request.get(APIURL.heart.rdcsm50.reportLogInfo, query);
}

// 主站IP地址及端口设置
export function sendPort(data) {
  return request.post(APIURL.heart.rdcsm50.sendPort, data);
}

// 请求主站IP及端口
export function sendPortInfo(data) {
  return request.post(APIURL.heart.rdcsm50.sendPortInfo, data);
}

// 修改状态
export function updateStatus(data) {
  return request.post(APIURL.heart.rdcsm50.updateStatus, data);
}

// 道路添加
export function addRoad(data) {
  return request.post(APIURL.heart.rdcsm50.addRoad, data);
}

// 道路列表
export function roadList(data) {
  return request.get(APIURL.heart.rdcsm50.roadList, data);
}

// 道路修改
export function updateRoad(data) {
  return request.post(APIURL.heart.rdcsm50.updateRoad, data);
}

// 道路删除
export function deleteRoad(data) {
  return request.post(APIURL.heart.rdcsm50.deleteRoad, data);
}

// 关联道路
export function connectRoad(data) {
  return request.post(APIURL.heart.rdcsm50.connectRoad, data);
}

// 道路详情
export function roadInfo(id) {
  var data = {
    id: id
  };
  return request.get(APIURL.heart.rdcsm50.roadInfo, data);
}

// 新增五零所单灯设备
export function addSingle50(data) {
  return request.post(APIURL.heart.rdcsm50.addSingle50, data);
}

// 单灯开关灯、调光状态变化及漏电告警
export function eventData(data) {
  return request.post(APIURL.heart.rdcsm50.eventData, data);
}

// 大于24小时离线的异常设备
export function offlineOver24h(data) {
  return request.post(APIURL.heart.rdcsm50.offlineOver24h, data);
}

// ------------------------------------------下面数据可视化接口----------------------------------------------------

// 设备类型数量统计
export function countStatistics(id) {
  var data = {
    uniqueId: id
  };
  return request.get(APIURL.heart.rdcsm50.countStatistics, data);
}

// 单灯能耗统计 day、week、month
export function electric50(data) {
  return request.post(APIURL.heart.rdcsm50.electric50, data);
}

// 箱体功率统计  day、week、month
export function powerRdc4m(data) {
  return request.post(APIURL.heart.rdcsm50.powerRdc4m, data);
}